import './my-spinner.css'

const MySpinner = () => {

    return (
        <div className="loader-container">
            <div className="custom-loader"/>
        </div>
    );
}

export default MySpinner;